import { ThumbsUpIcon } from '@m/alchemy-ui/icons/ThumbsUpIcon';
import { useIntl } from 'react-intl';
import { VotingType } from '../../../common/core-api';
import { useRuntimeCommunity } from '../../../context';
import * as Styled from './VoteActions.styled';

interface UpDownVoteProps {
  readonly votingType: VotingType.UP | VotingType.UPDOWN;
  readonly localVote: number | null;
  readonly disabled: boolean;
  readonly onVote: (direction: number) => void;
}

export const UpDownVote = ({ votingType, localVote, disabled, onVote }: UpDownVoteProps) => {
  const { colors } = useRuntimeCommunity();
  const intl = useIntl();
  const buttonColor = colors?.button ? `#${colors.button}` : '#4caf50';
  const isUpActive = localVote === 1;
  const isDownActive = localVote === -1;
  const voteUpLabel = intl.formatMessage({ id: 'voteUp', defaultMessage: 'Vote up' });
  const voteDownLabel = intl.formatMessage({ id: 'voteDown', defaultMessage: 'Vote down' });

  return (
    <Styled.VoteActionsWrap>
      <Styled.VoteButton
        $active={isUpActive}
        $variant="up"
        $buttonColor={buttonColor}
        disabled={disabled}
        onClick={() => onVote(1)}
        aria-label={voteUpLabel}
        title={voteUpLabel}
        type="button"
      >
        <ThumbsUpIcon aria-hidden="true" />
      </Styled.VoteButton>

      {votingType === VotingType.UPDOWN && (
        <Styled.VoteButtonDown
          $active={isDownActive}
          $variant="down"
          $buttonColor={buttonColor}
          disabled={disabled}
          onClick={() => onVote(-1)}
          aria-label={voteDownLabel}
          title={voteDownLabel}
          type="button"
        >
          <ThumbsUpIcon aria-hidden="true" />
        </Styled.VoteButtonDown>
      )}
    </Styled.VoteActionsWrap>
  );
};
